import { EventType, SbRrwebEvents } from 'sb-lib/types';
import { makeLog } from 'shared/utils/log';

const log = makeLog('rrweb-event-sink');

type SbRrwebEventsArray = SbRrwebEvents['events'];

let recordedRrwebEvents: SbRrwebEventsArray = [];
let recordedWidgetRrwebEvents: SbRrwebEventsArray = [];
const lastRecordedRrwebTimes = { event: 0, local: 0 };
const lastRecordedWidgetRrwebTimes = { event: 0, local: 0 };

export const recordRrwebEvents = (events: SbRrwebEventsArray) => {
  recordedRrwebEvents = _recordRrwebEvents(
    recordedRrwebEvents,
    events,
    lastRecordedRrwebTimes,
  );
};
export const recordWidgetRrwebEvents = (events: SbRrwebEventsArray) => {
  recordedWidgetRrwebEvents = _recordRrwebEvents(
    recordedWidgetRrwebEvents,
    events,
    lastRecordedWidgetRrwebTimes,
  );
};

const _recordRrwebEvents = (
  existingEvents: SbRrwebEventsArray,
  newEvents: SbRrwebEventsArray,
  times: typeof lastRecordedRrwebTimes,
) => {
  let events = [...existingEvents, ...newEvents];
  // If we just got a full snapshot, clean up the list to only include everything
  // after the snapshot, with the last meta event _before_ the snapshot up front.
  const snapshotIndex = newEvents.findIndex(ev => ev.type === EventType.FullSnapshot);
  if (snapshotIndex !== -1) {
    const lastSnapshotIndex = existingEvents.length + snapshotIndex;
    let lastMetaEvent: SbRrwebEventsArray = [];
    for (let i = lastSnapshotIndex - 1; i >= 0; i--) {
      if (events[i].type === EventType.Meta) {
        lastMetaEvent = [events[i]];
        break;
      }
    }
    events = [...lastMetaEvent, ...newEvents.slice(snapshotIndex)];
    log.debug(
      `Recorded a new snapshot, replacing ${existingEvents.length} old events with ${events.length} new ones`,
    );
  }
  // Update timestamps (mutatively)
  times.event = events[events.length - 1].timestamp;
  times.local = Date.now();
  return events;
};

export const getRecordedRrwebEvents = (): SbRrwebEventsArray => {
  return [...recordedRrwebEvents] as SbRrwebEventsArray;
};
export const getRecordedWidgetRrwebEvents = (): SbRrwebEventsArray => {
  return [...recordedWidgetRrwebEvents] as SbRrwebEventsArray;
};

export const clearRecordedRrwebEvents = () => {
  log.debug('Clearing recorded rrweb events');
  recordedRrwebEvents = [];
};
export const clearRecordedWidgetRrwebEvents = () => {
  log.debug('Clearing recorded rrweb widget events');
  recordedWidgetRrwebEvents = [];
};

export const clearAllRecordedRrwebEvents = () => {
  clearRecordedRrwebEvents();
  clearRecordedWidgetRrwebEvents();
};

export const getRrwebOffsetedNowTimestamp = () => {
  return _getOffsetNowTimestamp(lastRecordedRrwebTimes);
};
export const getWidgetRrwebOffsetNowTimestamp = () => {
  return _getOffsetNowTimestamp(lastRecordedWidgetRrwebTimes);
};
const _getOffsetNowTimestamp = (times: typeof lastRecordedRrwebTimes) => {
  const { event, local } = times;
  if (!event) {
    return Date.now();
  }
  const diff = Date.now() - local;
  return event + diff;
};
